export const Selector_Auth_Root = state => {
	return state.auth;
};

export const Selector_Auth_Principal = state => {
	return Selector_Auth_Root(state).principal;
};
